/**
 * Checkout Block - Frontend View
 *
 * @package YITH\AdvancedReviews\Modules\RequestReview\WCBlocks\Src\RequestReview
 */

import React from "react";
import metadata from './block.json';
import Block from './block';
import {useCallback, useEffect, useState} from "@wordpress/element";

// Global import.
const {registerCheckoutBlock} = wc.blocksCheckout;

const YWAR_Frontend_Block = ({checkoutExtensionData}) => {
	const [ywarAcceptRequests, setValue] = useState(false);
	
	const {setExtensionData} = checkoutExtensionData;
	useEffect(
		() => {
			setExtensionData('yith-ywar', 'ywarAcceptRequests', ywarAcceptRequests);
		},
		[]
	);
	
	const onChange = useCallback(
		(value) => {
			setValue(value);
			setExtensionData('yith-ywar', 'ywarAcceptRequests', value);
		},
		[setValue.setExtensionData]
	);
	if (!ywar_blocks.user_in_blocklist) {
		return (
			<Block
				checked={ywarAcceptRequests}
				onChange={onChange}
			/>
		);
	}
	
};

registerCheckoutBlock(
	{
		metadata,
		component: YWAR_Frontend_Block
	}
);
